var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1201 15.5918C30.1201 15.3984 29.9619 15.2402 29.7686 15.2402L26.8682 15.2534L22.5 20.4609L18.1362 15.2578L15.2314 15.2446C15.0381 15.2446 14.8799 15.3984 14.8799 15.5962C14.8799 15.6797 14.9106 15.7588 14.9634 15.8247L20.6807 22.6362L14.9634 29.4434C14.9103 29.5078 14.8808 29.5884 14.8799 29.6719C14.8799 29.8652 15.0381 30.0234 15.2314 30.0234L18.1362 30.0103L22.5 24.8027L26.8638 30.0059L29.7642 30.019C29.9575 30.019 30.1157 29.8652 30.1157 29.6675C30.1157 29.584 30.085 29.5049 30.0322 29.439L24.3237 22.6318L30.041 15.8203C30.0937 15.7588 30.1201 15.6753 30.1201 15.5918Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.85645C11.6279 2.85645 2.8125 11.6719 2.8125 22.5439C2.8125 33.416 11.6279 42.2314 22.5 42.2314C33.3721 42.2314 42.1875 33.416 42.1875 22.5439C42.1875 11.6719 33.3721 2.85645 22.5 2.85645ZM22.5 38.8916C13.4736 38.8916 6.15234 31.5703 6.15234 22.5439C6.15234 13.5176 13.4736 6.19629 22.5 6.19629C31.5264 6.19629 38.8477 13.5176 38.8477 22.5439C38.8477 31.5703 31.5264 38.8916 22.5 38.8916Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.790c0c6e9ec22f4cc0875c17df241ef4.svg";
export { ForwardRef as ReactComponent };